import Layout from "@/components/Layout";

export default function PageShell({ title, children }) {
  return <Layout title={title}>{children}</Layout>;
}
